import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';

import { EQAT_OIDC_CALLBACK_PATH, STATIC_ROUTES } from './constants';
import EQATRedirectionContainer from './containers/EQATRedirectionContainer';

const bypassedRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path={STATIC_ROUTES}
    >
      <Route path={STATIC_ROUTES+EQAT_OIDC_CALLBACK_PATH} element={<EQATRedirectionContainer />} />
    </Route>,
  ),
);

export default bypassedRoutes;
